/* src/app/shared/components/flow-pill/flow-pill.component.scss */
.flow-pill {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
}
.flow-pill .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 12px;
  width: 12px;
}
.flow-pill .icon {
  height: 12px;
  width: 12px;
  flex-shrink: 0;
  filter: brightness(0) saturate(100%) invert(45%) sepia(10%) saturate(279%) hue-rotate(202deg) brightness(95%) contrast(85%);
}
.flow-pill .pill-label {
  color: #71717a;
  white-space: nowrap;
}
.flow-pill:not(.active):not(.disabled):hover {
  background-color: #fafafa;
}
.flow-pill.active {
  background-color: #e0e9f9;
}
.flow-pill.active .pill-label {
  color: #3753be;
  font-family: "Poppins-Medium";
}
.flow-pill.active .icon {
  filter: brightness(0) saturate(100%) invert(32%) sepia(84%) saturate(940%) hue-rotate(200deg) brightness(98%) contrast(85%);
}
.flow-pill.active:not(.disabled):hover {
  background-color: #c8d9f5;
}
.flow-pill.disabled {
  cursor: not-allowed;
}
.flow-pill.disabled .pill-label {
  color: #a1a1aa;
}
/*# sourceMappingURL=flow-pill.component.css.map */
